// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"bf88344b","453":"b0e8e29e","557":"4297ab06"}[chunkId] + ".chunk.js";
};